/**
 * A tracking app a household can import finished rides from.
 *
 * Values match the service's own provider ids, which in turn match the ids the
 * screenshot extractor recognises apps by — so one app is called one thing
 * whether its rides arrived as a picture or over its API.
 */
export enum TrackerProvider {
  Strava = "strava",
}
